import { delay } from '@shared/util/delay'
import NProgress from '@shared/util/nprogress'
import { RedirectError } from '@shared/constants/error'
import { routerModuleErrorHandler } from '@shared/util/router'
import { createRouter, createWebHistory } from 'vue-router'
import { validModule, validToken, validUser } from './util.validate'
import { ROUTES } from './route'
import { CustomBiConfig, customPageViewBiLogger } from '@/api/bi'

export const router = createRouter({
  history: createWebHistory(),
  routes: ROUTES,
})
routerModuleErrorHandler(router)

export const route = ref(router.currentRoute.value)
router.beforeEach((to, from, next) => {
  // TODO 由于暂时没有官网，重定向到登录
  if (to.path === '/') {
    next({
      name: 'Login',
    })
    return
  }
  if (to.name !== from.name) {
    NProgress.start()
  }
  route.value = to

  validToken(to)
    .then(() => validUser(to))
    .then(() => validModule(to))
    .then(() => next())
    .catch((err) => {
      if (err instanceof RedirectError) {
        next({ ...err.route })
      } else {
        next({ name: 'notFound' })
      }
    })
    .then(() => {
      if (to.name !== from.name) {
        customPageViewBiLogger.log({
          biz: CustomBiConfig.Biz,
          pageName: to.name as string,
          referPage: from.name as string,
        })
      }
    })
    .then(() => delay(50))
    .finally(() => NProgress.done())
})

export default router
